import { Menu, MenuItem } from '@mui/material';
import { IconLayout } from '@tabler/icons';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import { ComponentProps, RefObject } from 'react';
import { FormattedMessage } from 'react-intl';
import ControlButton from './ControlButton';

export type Layout = 'grid' | 'just-me' | 'just-them' | 'left-sidebar' | 'picture-in-picture' | 'pinned';

interface Props extends ComponentProps<typeof ControlButton> {
  onLayoutChange: (value: Layout) => void;
  draggableRef: any;
  whiteboardOpen: boolean;
  containerRef: RefObject<HTMLDivElement> | null;
}

export default function LayoutButton({ onLayoutChange, draggableRef, whiteboardOpen, containerRef, ...props }: Props) {
  const popupState = usePopupState({ variant: 'popover', popupId: 'layout-menu' });

  /**
   * Reset picture-in-picture draggable to original position
   */
  const resetDraggable = () => {
    if (draggableRef?.current) {
      draggableRef.current.state.x = 0;
      draggableRef.current.state.y = 0;
    }
  };

  return (
    <>
      <ControlButton {...bindTrigger(popupState)} startIcon={<IconLayout size={20} />} {...props}>
        <FormattedMessage defaultMessage="Layout" />
      </ControlButton>

      <Menu
        container={containerRef?.current}
        {...bindMenu(popupState)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        {!whiteboardOpen && (
          <MenuItem
            onClick={() => {
              onLayoutChange('grid');
              resetDraggable();
              popupState.close();
            }}
          >
            Grid
          </MenuItem>
        )}
        {!whiteboardOpen && (
          <MenuItem
            onClick={() => {
              onLayoutChange('just-me');
              resetDraggable();
              popupState.close();
            }}
          >
            Just Me
          </MenuItem>
        )}
        {!whiteboardOpen && (
          <MenuItem
            onClick={() => {
              onLayoutChange('just-them');
              popupState.close();
            }}
          >
            Just Them
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            onLayoutChange('left-sidebar');
            resetDraggable();
            popupState.close();
          }}
        >
          Left Sidebar
        </MenuItem>
        {!whiteboardOpen && (
          <MenuItem
            onClick={() => {
              onLayoutChange('picture-in-picture');
              popupState.close();
            }}
          >
            Picture in Picture
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
